/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { decodeToken } from "react-jwt";
import { Link, useNavigate } from "react-router-dom";
import Cookies from "universal-cookie";
import PrimaryButtonPageLevel from "../../../components/button/primary-button/PrimaryButtonLevelPage";
import InputText from "../../../components/input/InputText";
import BackgroundImageFromUrl from "../../../components/parseImage/BackgroundImageFromUrl";
import { getUserInfo, signin } from "../../../config/auth";
import ConstantStrings from "../../../constants/ConstantStrings";
import { getConstantStringByLanguage } from "../../../templates/helper/getConstantStringByLanguage";
import { updateGrade } from "../../../config/ListLesson";

function Signin() {
  var backgroundImage = {
    backgroundPosition: "center center",
    backgroundRepeat: "no-repeat",
    backgroundAttachment: "fixed",
    backgroundSize: "cover",
  };
  const [account, setAccount] = useState({
    userName: "",
    password: "",
  });
  const [error, setError] = useState({
    userName: "",
    password: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const cookies = new Cookies();
  const navigate = useNavigate();

  const handleChange = (value, index, name) => {
    setAccount({ ...account, [name]: value });
    setError({
      userName: "",
      password: "",
    });
  };

  const handleLoginOAuth = () => {
    const callbackUrl = process.env.REACT_APP_CALLBACK_URL || "";
    const authUri = process.env.REACT_APP_AUTH_URI;
    const googleClientId = process.env.REACT_APP_CLIENT_ID;
    const targetUrl = `${authUri}?redirect_uri=${encodeURIComponent(
      callbackUrl
    )}&response_type=token&client_id=${googleClientId}&scope=openid%20email%20profile&&prompt=select_account`;
    window.location.href = targetUrl;
  };

  const handleSubmit = async (e) => {
    e?.preventDefault();
    // const regex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,50}$/;
    if (account.password === "" || account.userName === "") {
      account.password === ""
        ? setError({
            ...error,
            password: getConstantStringByLanguage(
              ConstantStrings.DO_NOT_LEAVE_BLANK
            ),
          })
        : setError({
            ...error,
            userName: getConstantStringByLanguage(
              ConstantStrings.DO_NOT_LEAVE_BLANK
            ),
          });
    } else {
      try {
        const login = await signin(account);
        var expires = 7 * 24 * 3600;
        if (cookies.get("signinUser")) {
          cookies.remove("signinUser");
        }
        cookies.set("signinUser", login.access_token, {
          maxAge: expires,
          path: "/",
          // httpOnly: true,
        });

        const decode = decodeToken(login.access_token);
        setError({
          userName: "",
          password: "",
        });
        cookies.remove("lessonId");
        cookies.remove("unitId");
        setIsLoading(true);
        const { result } = await getUserInfo();
        if (ConstantStrings.GRADE_ID_HIDES.includes(result?.gradeId)) {
          await updateGrade({ gradeId: ConstantStrings.GRADE_1_ID });
        }
        setTimeout(() => {
          if (decode.phone === "" || decode.phone.length === 0) {
            navigate("/validate-phone");
          } else if (
            result.fullName === "" ||
            result.birthday === "" ||
            result.gradeId === "" ||
            result.gradeId === null ||
            result.gradeName === "" ||
            result.gradeName === null
          ) {
            navigate("/calibration");
          } else {
            if (!decode?.firstLogin) {
              navigate("/");
            } else {
              navigate("/upgrade");
            }
          }
        }, 1000);
      } catch (error) {
        setError({
          ...error,
          userName: error.response.data?.errorMessage,
          password: error.response.data?.errorMessage,
        });
      }
    }
  };

  useEffect(() => {
    localStorage.clear();
    if (cookies.get("signinUser")) {
      if (!decodeToken(cookies.get("signinUser"))?.firstLogin) {
        navigate("/");
      } else {
        navigate("/upgrade");
      }
    }
  }, [navigate]);
  return (
    <BackgroundImageFromUrl
      objectId="admin/frontend-images/auth/bg-desktop-signin.svg"
      className=""
      style={backgroundImage}
    >
      <div
        className="columns m-0 p-0 is-justify-content-center is-align-content-flex-start"
        style={{ minHeight: "100vh", width: "100%" }}
      >
        {isLoading && (
          <>
            <div className="column m-0 p-0 is-relative">
              <div
                style={{
                  width: "15rem",
                  margin: "24.4375rem 0 0 5rem",
                }}
              >
                <p
                  style={{ fontSize: "1.125rem" }}
                  className="mb-4 has-text-kurio-main-color-white is-uppercase"
                >
                  Đang tải
                </p>
                <span
                  className="loader__quiz"
                  style={{ width: "15rem" }}
                ></span>
              </div>
              <div
                style={{
                  width: "21.5rem",
                  height: "8.3125rem",
                  backgroundImage: "url('/images/auth/logo-signin.svg')",
                  backgroundPosition: "center center",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "cover",
                  position: "absolute",
                  left: "0",
                  bottom: "0",
                }}
              ></div>
            </div>
            <BackgroundImageFromUrl
              objectId="admin/frontend-images/auth/image-left-signin.svg"
              style={{
                width: "42.9375rem",
                height: "47rem",
                backgroundPosition: "center center",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                marginRight: "8.375rem",
              }}
            ></BackgroundImageFromUrl>
            <div
              style={{
                height: "7.5rem",
                width: "7.443125rem",
                position: "absolute",
                bottom: "5.625rem",
                right: "6rem",
                // transform: "rotate(2deg)",
                backgroundImage:
                  "url('/images/auth/floating-element-signin.svg')",
                backgroundPosition: "center center",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
              }}
            ></div>
          </>
        )}
        {!isLoading && (
          <>
            <div className="column m-0 p-0 is-relative">
              <BackgroundImageFromUrl
                objectId="admin/frontend-images/auth/image-left-signin.svg"
                style={{
                  width: "42.9375rem",
                  height: "47rem",
                  backgroundPosition: "center center",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "cover",
                  marginLeft: "4.625rem",
                }}
              ></BackgroundImageFromUrl>
              <div
                style={{
                  width: "21.5rem",
                  height: "8.3125rem",
                  backgroundImage: "url('/images/auth/logo-signin.svg')",
                  backgroundPosition: "center center",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "cover",
                  position: "absolute",
                  left: "0",
                  bottom: "0",
                }}
              ></div>
            </div>
            <div
              className="column is-flex is-flex-direction-column is-align-items-center is-justify-content-space-between has-background-white  has-text-kurio-main-color-black"
              style={{
                padding: "3.1875rem 4rem 2.5rem 3.5rem",
                width: "27.5rem",
                height: "40rem",
                marginRight: "5.25rem",
                marginTop: "3.4375rem",
                maxWidth: "27.5rem",
                position: "relative",
                boxShadow: "0.75rem 0.6875rem #290E76",
                border: "0.25rem solid #C4B5F2",
                borderRadius: "7.5rem",
              }}
            >
              <div
                style={{
                  height: "7.5rem",
                  width: "7.443125rem",
                  position: "absolute",
                  bottom: "3rem",
                  left: "-5.25rem",
                  // transform: "rotate(2deg)",
                  backgroundImage:
                    "url('/images/auth/floating-element-signin.svg')",
                  backgroundPosition: "center center",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "cover",
                }}
              ></div>
              <form onSubmit={handleSubmit} noValidate>
                <input hidden type="submit" />
                <div
                  className="is-flex is-flex-direction-column is-align-items-center p-0"
                  style={{ gap: "2rem" }}
                >
                  <h2
                    style={{ fontSize: "2.25rem", lineHeight: "2.75rem" }}
                    className=" has-text-weight-bold is-uppercase"
                  >
                    Đăng nhập
                  </h2>
                  {error.error && (
                    <p className="has-text-danger has-text-centered subtitle is-size-6">
                      {error.error}
                    </p>
                  )}
                  <div style={{ width: "20rem", height: "5rem" }}>
                    <InputText
                      label={"Số điện thoại / Email"}
                      type="text"
                      value={account.userName}
                      name={"userName"}
                      onChange={(e) =>
                        handleChange(e.target.value, 0, e.target.name)
                      }
                    />
                    {error.email && (
                      <p className="has-text-danger subtitle is-size-6">
                        {error.email}
                      </p>
                    )}
                  </div>
                  <div style={{ width: "20rem", height: "5rem" }}>
                    <InputText
                      label={"Mật khẩu"}
                      type="password"
                      value={account.password}
                      name="password"
                      onChange={(e) =>
                        handleChange(e.target.value, 0, e.target.name)
                      }
                    />

                    {error.password && (
                      <p className="has-text-danger subtitle is-size-6">
                        {error.password}
                      </p>
                    )}
                  </div>
                  <PrimaryButtonPageLevel
                    onClick={handleSubmit}
                    style={{
                      height: "4rem",
                      width: "20rem",
                      maxWidth: "20rem",
                    }}
                    type="submit"
                  >
                    Đăng nhập
                  </PrimaryButtonPageLevel>
                  <div className="is-flex is-flex-direction-column is-flex-gap-2 is-align-items-center is-justify-content-center" style={{ marginTop: "-1.25rem" }}>
                    <p className="has-text-weight-bold" style={{ fontSize: "1rem" }}>Hoặc</p>
                    <div
                      className="has-tex-weight-bold is-flex is-align-items-center is-clickable is-flex-gap-2 py-2 px-4 is-justify-content-center"
                      style={{
                        border: "1px solid #0A2A66",
                        borderRadius: "1rem",
                        // width: "20rem"
                      }}
                      onClick={handleLoginOAuth}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 326667 333333"
                        shapeRendering="geometricPrecision"
                        textRendering="geometricPrecision"
                        imageRendering="optimizeQuality"
                        fillRule="evenodd"
                        clipRule="evenodd"
                        width={20}
                        height={20}
                      >
                        <path
                          d="M326667 170370c0-13704-1112-23704-3518-34074H166667v61851h91851c-1851 15371-11851 38519-34074 54074l-311 2071 49476 38329 3428 342c31481-29074 49630-71852 49630-122593m0 0z"
                          fill="#4285f4"
                        />
                        <path
                          d="M166667 333333c44999 0 82776-14815 110370-40370l-52593-40742c-14074 9815-32963 16667-57777 16667-44074 0-81481-29073-94816-69258l-1954 166-51447 39815-673 1870c27407 54444 83704 91852 148890 91852z"
                          fill="#34a853"
                        />
                        <path
                          d="M71851 199630c-3518-10370-5555-21482-5555-32963 0-11482 2036-22593 5370-32963l-93-2209-52091-40455-1704 811C6482 114444 1 139814 1 166666s6482 52221 17777 74814l54074-41851m0 0z"
                          fill="#fbbc04"
                        />
                        <path
                          d="M166667 64444c31296 0 52406 13519 64444 24816l47037-45926C249260 16482 211666 1 166667 1 101481 1 45185 37408 17777 91852l53889 41853c13520-40185 50927-69260 95001-69260m0 0z"
                          fill="#ea4335"
                        />
                      </svg>
                      Đăng nhập với Google
                    </div>
                  </div>
                  <Link
                    to={"/reset-password"}
                    className="is-underlined is-clickable has-text-kurio-main-color-black"
                  >
                    Quên mật khẩu?
                  </Link>
                </div>
              </form>
              <div
                className="has-text-centered is-flex is-flex-direction-column is-align-items-center"
                style={{ gap: "1rem" }}
              >
                <Link
                  className=" has-text-kurio-main-color-black"
                  to="/register"
                >
                  <p style={{ fontSize: "0.875rem" }}>
                    <span className=" mr-2">Chưa có tài khoản ?</span>
                    <span className="has-text-weight-bold is-underlined">
                      Đăng ký
                    </span>
                  </p>
                </Link>
              </div>
            </div>
          </>
        )}
      </div>
    </BackgroundImageFromUrl>
  );
}

export default Signin;
